import ReactGA from "react-ga4";

export const useGoogleAnalytics = () => {
  const logEvent = (category: string, action: string) => {
    ReactGA.event({
      category: category,
      action: action,
    });
  };

  return { logEvent };
};
